import { LangSelectProfile } from 'config';
import { Colors } from 'enums';
import { StylesConfig } from 'react-select';

export const languageStyleCustom: StylesConfig<LangSelectProfile> = {
  container: (base) => ({
    ...base,
    width: '100%',
    fontFamily: 'Inter, sans-serif',
    fontSize: 14,
    cursor: 'pointer',
    textAlign: 'left',
    boxShadow: 'none',
  }),
  control: (base, { isFocused, menuIsOpen }) => ({
    ...base,
    height: 48,
    padding: '0 16px',
    backgroundColor: Colors.white,
    borderRadius: 10,
    cursor: 'pointer',
    border: `1px solid ${
      isFocused && menuIsOpen ? Colors.yellow1 : 'transparent'
    }`,
    boxShadow: 'none',
    '&:hover': {
      border: `1px solid ${isFocused ? Colors.yellow1 : 'transparent'}`,
    },
  }),
  menu: (base) => ({
    ...base,
    borderRadius: 10,
    border: 'none',
    boxShadow: '0px 4px 15px 4px rgba(0, 0, 0, 0.08);',
  }),
  menuList: (base) => ({
    ...base,
    borderRadius: 10,
    '::-webkit-scrollbar': {
      width: 4,
    },
    '::-webkit-scrollbar-thumb': {
      background: Colors.yellow1,
      borderRadius: 2,
    },
    '::-webkit-scrollbar-thumb:hover': {
      background: Colors.yellow2,
    },
  }),
  singleValue: (base) => ({
    ...base,
    height: '100%',
  }),
  valueContainer: (base) => ({
    ...base,
    padding: '0px 8px',
    input: {
      height: '100%',
    },
  }),
  option: (base) => ({
    ...base,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: Colors.white,
    color: Colors.gray1,
    padding: '18px 24px',
    cursor: 'pointer',
    '&:active': {
      backgroundColor: 'transparent',
    },
    '&:hover': {
      backgroundColor: Colors.background,
    },
  }),
  dropdownIndicator: (base, props) => ({
    ...base,
    transition: 'all .2s ease',
    transform: props.selectProps.menuIsOpen ? 'rotate(180deg)' : '',
  }),
};
